import PackageIcon from "@redotech/redo-icons/package.svg";
import { BooleanFilterOperator } from "@redotech/redo-model/views/advanced-filters/boolean-filter";
import { AdvancedFilterType } from "@redotech/redo-model/views/advanced-filters/generic-advanced-filter-data";
import { BooleanTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

export const UsedParcelLearningFilter: BooleanTableFilter = {
  type: AdvancedFilterType.BOOLEAN,
  data: {
    name: "usedParcelLearning",
    type: AdvancedFilterType.BOOLEAN,
    value: null,
    operator: BooleanFilterOperator.IS,
  },
  Icon: PackageIcon,
  displayName: "Used package learning",
  label: "Package learning",
  boolDisplay: { falseDisplay: "not used", trueDisplay: "used" },
};
